
import React, { useState, KeyboardEvent } from "react";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

type TagInputProps = {
  tags: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  className?: string;
};

export const TagInput = ({ tags, onChange, placeholder = "Add tags...", className = "" }: TagInputProps) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      
      const trimmedInput = inputValue.trim().toLowerCase();
      
      // Don't add empty tags or duplicates
      if (trimmedInput !== '' && !tags.includes(trimmedInput)) {
        onChange([...tags, trimmedInput]);
      }
      
      setInputValue("");
    }
  };

  const removeTag = (tagToRemove: string) => {
    onChange(tags.filter(tag => tag !== tagToRemove));
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className="flex flex-wrap gap-1 mb-1">
        {tags.map((tag) => (
          <Badge 
            key={tag} 
            variant="secondary" 
            className="text-xs py-0 pr-1 pl-2 flex items-center gap-1"
          >
            {tag}
            <X 
              className="w-3 h-3 cursor-pointer hover:text-destructive" 
              onClick={() => removeTag(tag)} 
            />
          </Badge>
        ))}
      </div>
      <Input
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="w-full"
      />
      <p className="text-xs text-muted-foreground">
        Press Enter or comma to add a tag
      </p>
    </div>
  );
};
